export const SCROLL_TO_TOP_ID = 'scroll-to-top';

export const scrollToTop = () => {
  if (window?.innerWidth > 1024) {
    const el = document.getElementById(SCROLL_TO_TOP_ID);
    if (!el) {
      throw new Error(`cannot scroll to top: no element by id ${SCROLL_TO_TOP_ID}`);
    }
    el.scrollIntoView({ block: 'start', behavior: 'smooth' });
  } else {
    // Scroll to the top when show mobile Wix Header
    window.scroll({ left: 0, top: 0, behavior: 'smooth' });
  }
};
